import {LanguageSwitcherToggleComponent} from "./component/language-switcher-toggle";
import {Application} from "./application/application";
import {ComponentService} from "./service/component";
import EventsHandler from "./service/events";
import {NavigationToggleComponent} from "./component/navigation-toggle";
import {AnimationService} from "./service/animation";
import {NavigationComponent} from "./component/navigation";
import {LanguageSwitcherComponent} from "./component/language-switcher";

require("@babel/polyfill");
// require("./utils/events.ts");

(($) => $(() => {

    let components = new ComponentService();
    (<any>window).events = undefined === (<any>window).events ? new EventsHandler() : (<any>window).events;
    components.addComponent('.js-language-switcher', LanguageSwitcherComponent, 'LanguageSwitcherComponent');
    components.addComponent('.js-language-switcher-toggle', LanguageSwitcherToggleComponent, 'LanguageSwitcherToggleComponent');
    components.addComponent('.js-navigation', NavigationComponent, 'NavigationComponent');
    components.addComponent('.js-navigation-toggle', NavigationToggleComponent, 'NavigationToggleComponent');
    new Application(components, (<any>window).events, null, new AnimationService());

}))(jQuery);